module.exports = __webpack_public_path__ + "static/media/29ADMSPC27.f29a3b81.jpg";